import { MutationTree } from 'vuex';
import { EContentLinkMutation } from '@/content-link/store/content-link.constants';
import { IContentLinkBlock } from '@/content-link/types/content-link';
import { IContentLinkBlockState } from '@/content-link/store/content-link.types';

export const mutations: MutationTree<IContentLinkBlockState> = {
  [EContentLinkMutation.SetPreview](
    state: IContentLinkBlockState,
    contentLinkBlock: IContentLinkBlock
  ) {
    state.preview = { ...state.preview, ...contentLinkBlock };
  },
  [EContentLinkMutation.SetLoading](state: IContentLinkBlockState, loading: boolean) {
    state.loading = loading;
  },
  [EContentLinkMutation.SetLoaded](state: IContentLinkBlockState, loaded: boolean) {
    state.loaded = loaded;
  },
  [EContentLinkMutation.SetSaving](state: IContentLinkBlockState, saving: boolean) {
    state.saving = saving;
  },
  [EContentLinkMutation.ClearData](
    state: IContentLinkBlockState,
    defaultState: IContentLinkBlockState
  ) {
    state.loaded = defaultState.loaded;
    state.loading = defaultState.loading;
    state.saving = defaultState.saving;
    state.preview = defaultState.preview;
    state.message = defaultState.message;
    state.validUrl = defaultState.validUrl;
    state.created = defaultState.created;
  },
  [EContentLinkMutation.SetURLValidation](state: IContentLinkBlockState, valid?: boolean) {
    state.validUrl = valid;
  },
  [EContentLinkMutation.SetMessage](state: IContentLinkBlockState, message?: string) {
    state.message = message;
  },
  [EContentLinkMutation.SetIsCreated](state: IContentLinkBlockState, created: boolean) {
    state.created = created;
  },
};
